var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUserPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "transparent",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#UserPlus_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.666 14v-1.333A2.667 2.667 0 0 0 7.999 10H3.333a2.667 2.667 0 0 0-2.667 2.667V14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.666 14v-1.333A2.667 2.667 0 0 0 7.999 10H3.333a2.667 2.667 0 0 0-2.667 2.667V14M13.333 5.334v4M15.333 7.333h-4M5.667 7.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333Z",
  stroke: "currentColor",
  strokeWidth: 1.667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "UserPlus_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})))));

export default SvgUserPlus;